window.addEventListener("load", (event) => {
  initFunctions();
  sticky_header();
  current_device();
  animate();
  calc_height();
  window.dispatchEvent(new Event("resize"));
});

window.addEventListener("resize", (event) => {
  current_device();
  calc_height();
});

window.addEventListener("scroll", function () {
  sticky_header();
  animate();
});

function initFunctions() {
  // start global function

  // Toggle class function

  let toggle_func_el = document.querySelectorAll(
    '[data-function="toggle-class"]:not(.function-enabled)'
  );
  toggle_func_el.forEach(function (a) {
    a.classList.add("function-enabled");
    a.onclick = function () {
      resize();
      // on click on element with function
      let data_target = a.dataset.target;
      // check if data-target is defined
      if (data_target != undefined) {
        let target = data_target.split("&");
        // loop in targeted class
        target.forEach(function (b) {
          let targeted_el = document.querySelectorAll(b);

          targeted_el.forEach(function (c) {
            let data_class = a.dataset.class;
            // check if data-class is defined
            if (data_class != undefined) {
              var target_class = data_class;
            } else {
              var target_class = "active";
            }
            // toggle class
            if (c.classList.contains(target_class)) {
              // check is has animation enabled
              let data_animation = a.dataset.animation;
              if (data_animation) {
                c.classList.remove("animation-in");
                c.classList.add("animation-out");
                setTimeout(function () {
                  c.classList.remove(target_class);
                }, 300);
              } else {
                c.classList.remove(target_class);
              }
            } else {
              // check is has animation enabled
              let data_animation = a.dataset.animation;
              if (data_animation) {
                c.classList.add(target_class);
                c.classList.remove("animation-out");
                c.classList.add("animation-in");
              } else {
                c.classList.add(target_class);
              }
            }
          });
        });
      } else {
        console.warn("you forgot data-target attribute");
      }
    };
  });

  // Remove class function

  let remove_func_el = document.querySelectorAll(
    '[data-function="remove-class"]:not(.function-enabled)'
  );
  remove_func_el.forEach(function (a) {
    a.classList.add("function-enabled");
    a.onclick = function () {
      resize();
      // on click on element with function
      let data_target = a.dataset.target;
      // check if data-target is defined
      if (data_target != undefined) {
        let target = data_target.split("&");
        // loop in targeted class
        target.forEach(function (b) {
          let targeted_el = document.querySelectorAll(b);

          targeted_el.forEach(function (c) {
            let data_class = a.dataset.class;
            // check if data-class is defined
            if (data_class != undefined) {
              var target_class = data_class;
            } else {
              var target_class = "active";
            }
            // remove class
            if (c.classList.contains(target_class)) {
              // check is has animation enabled
              let data_animation = a.dataset.animation;
              if (data_animation) {
                c.classList.remove("animation-in");
                c.classList.add("animation-out");
                setTimeout(function () {
                  c.classList.remove(target_class);
                }, 300);
              } else {
                c.classList.remove(target_class);
              }
            }
          });
        });
      } else {
        console.warn("you forgot data-target attribute");
      }
    };
  });

  // Add class function

  let add_func_el = document.querySelectorAll(
    '[data-function="add-class"]:not(.function-enabled)'
  );
  add_func_el.forEach(function (a) {
    a.classList.add("function-enabled");
    a.onclick = function () {
      resize();
      // on click on element with function
      let data_target = a.dataset.target;
      // check if data-target is defined
      if (data_target != undefined) {
        let target = data_target.split("&");
        // loop in targeted class
        target.forEach(function (b) {
          let targeted_el = document.querySelectorAll(b);

          targeted_el.forEach(function (c) {
            let data_class = a.dataset.class;
            // check if data-class is defined
            if (data_class != undefined) {
              var target_class = data_class;
            } else {
              var target_class = "active";
            }
            // add class
            c.classList.add(target_class);
            // check is has animation enabled
            let data_animation = a.dataset.animation;
            if (data_animation) {
              c.classList.remove("animation-out");
              c.classList.add("animation-in");
            }
          });
        });
      } else {
        console.warn("you forgot data-target attribute");
      }
    };
  });

  // Plus button function

  let qty_plus_func_el = document.querySelectorAll(
    '[data-function="qty-plus"]:not(.function-enabled)'
  );
  qty_plus_func_el.forEach(function (a) {
    a.classList.add("function-enabled");
    let data_target = a.dataset.target;
    // check if data-target is defined
    if (data_target != undefined) {
      let input_value = Number(document.querySelector(data_target).value);

      // update state on load
      if (input_value == a.dataset.max) {
        a.disabled = true;
      }

      // update state on qty change
      document
        .querySelector(data_target)
        .addEventListener("change", function () {
          let updated_qty = Number(document.querySelector(data_target).value);
          if (updated_qty == a.dataset.max) {
            a.disabled = true;
          } else {
            a.disabled = false;
          }
        });

      a.onclick = function () {
        // on click on element with function
        let input_value = Number(document.querySelector(data_target).value);
        if (input_value < a.dataset.max) {
          let new_qty = input_value + 1;
          document.querySelector(data_target).value = new_qty;
          // trigger change event on input field
          const e = new Event("change");
          const element = document.querySelector(data_target);
          element.dispatchEvent(e);
        }
      };
    } else {
      console.warn("you forgot data-target attribute");
    }
  });

  // Minus button function

  let qty_minus_func_el = document.querySelectorAll(
    '[data-function="qty-minus"]:not(.function-enabled)'
  );
  qty_minus_func_el.forEach(function (a) {
    a.classList.add("function-enabled");
    let data_target = a.dataset.target;
    // check if data-target is defined
    if (data_target != undefined) {
      let input_value = Number(document.querySelector(data_target).value);

      // update state on load
      if (input_value == a.dataset.min) {
        a.disabled = true;
      }

      // update state on qty change
      document
        .querySelector(data_target)
        .addEventListener("change", function () {
          let updated_qty = Number(document.querySelector(data_target).value);
          if (updated_qty == a.dataset.min) {
            a.disabled = true;
          } else {
            a.disabled = false;
          }
        });

      a.onclick = function () {
        // on click on element with function
        let input_value = Number(document.querySelector(data_target).value);
        if (input_value > a.dataset.min) {
          let new_qty = input_value - 1;
          document.querySelector(data_target).value = new_qty;
          // trigger change event on input field
          const e = new Event("change");
          const element = document.querySelector(data_target);
          element.dispatchEvent(e);
        }
      };
    } else {
      console.warn("you forgot data-target attribute");
    }
  });

  // Edit atc btn qty function

  let edit_atc_qty_func_el = document.querySelectorAll(
    '[data-function="edit-atc-qty"]:not(.function-enabled)'
  );
  edit_atc_qty_func_el.forEach(function (a) {
    a.classList.add("function-enabled");
    // on click on element with function
    let data_target = a.dataset.target;
    // check if data-target is defined
    if (data_target != undefined) {
      let target = data_target.split("&");
      a.addEventListener("change", function () {
        let new_qty = Number(a.value);
        // loop in targeted class
        target.forEach(function (b) {
          let targeted_el = document.querySelector(b);
          targeted_el.dataset.qty = new_qty;
        });
      });
    } else {
      console.warn("you forgot data-target attribute");
    }
  });

  // Toggle audio on video function

  let toggle_video_audio_func_el = document.querySelectorAll(
    '[data-function="toggle-video-audio"]:not(.function-enabled)'
  );
  toggle_video_audio_func_el.forEach(function (a) {
    a.classList.add("function-enabled");
    // on click on element with function
    let data_target = a.dataset.target;
    // check if data-target is defined
    if (data_target != undefined) {
      a.onclick = function () {
        let video = document.querySelector(data_target);
        if (video.muted) {
          video.muted = false;
        } else {
          video.muted = true;
        }
      };
    } else {
      console.warn("you forgot data-target attribute");
    }
  });

  // Toggle play on video function

  let toggle_video_play_func_el = document.querySelectorAll(
    '[data-function="toggle-video-play"]:not(.function-enabled)'
  );
  toggle_video_play_func_el.forEach(function (a) {
    a.classList.add("function-enabled");
    a.style.cursor = "pointer";
    // on click on element with function
    let data_target = a.dataset.target;
    // check if data-target is defined
    if (data_target != undefined) {
      a.onclick = function () {
        let video = document.querySelector(data_target);
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      };
    } else {
      console.warn("you forgot data-target attribute");
    }
  });

  // dispacth specific event when done playing

  window.dispatchEvent(new Event("functions-enabled"));

  // countdown module

  let countdown_el = document.querySelectorAll('[data-function="countdown"]');
  countdown_el.forEach(function (item) {
    item.classList.add("function-enabled");
    const dateSetting = item.dataset.date;
    const day_txt = item.dataset.day;
    const days_txt = item.dataset.days;
    const hour_txt = item.dataset.hour;
    const hours_txt = item.dataset.hours;
    const minute_txt = item.dataset.minute;
    const minutes_txt = item.dataset.minutes;
    if (dateSetting) {
      const countDownDate = new Date(dateSetting).getTime();
      const x = setInterval(() => {
        const now = new Date().getTime();
        const distance = countDownDate - now;
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const days_str = days < 10 ? "0" + days : days;
        const hours_str = hours < 10 ? "0" + hours : hours;
        const minutes_str = minutes < 10 ? "0" + minutes : minutes;
        const seconds_str = seconds < 10 ? "0" + seconds : seconds;
        const day_label = days <= 1 ? day_txt : days_txt;
        const hour_label = hours <= 1 ? hour_txt : hours_txt;
        const minute_label = minutes <= 1 ? minute_txt : minutes_txt;

        item.querySelector("#countdown_days").innerHTML = days_str;
        item.querySelector("#countdown_hours").innerHTML = hours_str;
        item.querySelector("#countdown_minutes").innerHTML = minutes_str;
        item.querySelector("#countdown_seconds").innerHTML = seconds_str;
        item.querySelector("#countdown_days_string").innerHTML = day_label;
        item.querySelector("#countdown_hours_string").innerHTML = hour_label;
        item.querySelector("#countdown_minutes_string").innerHTML =
          minute_label;
      }, 1000);
    } else {
      console.error("date parameter is missing");
    }
  });

  // end global function
}

// handle devices

function current_device() {
  var current_width = window.innerWidth;
  if (current_width < 576) {
    document.querySelector("body").classList.remove("is-desktop");
    document.querySelector("body").classList.remove("is-tablet");
    document.querySelector("body").classList.add("is-mobile");
  } else if (current_width >= 768 && current_width < 992) {
    document.querySelector("body").classList.remove("is-mobile");
    document.querySelector("body").classList.remove("is-desktop");
    document.querySelector("body").classList.add("is-tablet");
  } else if (current_width >= 992) {
    document.querySelector("body").classList.remove("is-mobile");
    document.querySelector("body").classList.remove("is-tablet");
    document.querySelector("body").classList.add("is-desktop");
  }
}

// animation when on screen

function animate() {
  let animate_func_el = document.querySelectorAll(
    '[data-function="animate"]:not(.animation-in)'
  );
  animate_func_el.forEach(function (a, b) {
    a.classList.add("function-enabled");
    let position = a.getBoundingClientRect();
    let position_top = position.top - window.innerHeight;
    let third_height = 0 - a.offsetHeight / 3;
    if (position_top <= third_height) {
      setTimeout(() => {
        a.classList.add("animation-in");
        a.style.opacity = "initial";
      }, b * 200);
    }
  });
}

// Handle stikcy header

function sticky_header() {
  // TODO: After A/B testing, revert to simple version
  // Old version: let sticky_header = document.querySelector("[data-function='sticky-header']");
  // Why changed: During A/B testing, both headers have data-function="sticky-header", so we need
  // to select the correct active header (prioritize header-v2 if visible)
  
  let sticky_header;
  const headerV2 = document.querySelector("header.header-v2[data-function='sticky-header']");
  const headerOriginal = document.querySelector("header:not(.header-v2)[data-function='sticky-header']");
  
  // Check if header-v2 exists and is visible
  if (headerV2) {
    const headerV2Style = window.getComputedStyle(headerV2);
    if (headerV2Style.display !== "none" && headerV2Style.visibility !== "hidden") {
      sticky_header = headerV2;
    }
  }
  
  // Fallback to original header if v2 not visible or doesn't exist
  if (!sticky_header && headerOriginal) {
    sticky_header = headerOriginal;
  }
  
  // Final fallback to any header with the attribute
  if (!sticky_header) {
    sticky_header = document.querySelector("[data-function='sticky-header']");
  }
  
  if (sticky_header) {
    sticky_header.classList.add("function-enabled");
    let header_height = sticky_header.offsetHeight;
    let data_target = sticky_header.dataset.target;
    // check if data-target is defined
    if (data_target != undefined) {
      var target_height = document.querySelector(data_target).offsetHeight;
    } else {
      var target_height = 0;
    }

    if (window.scrollY > target_height) {
      sticky_header.style.position = "fixed";
      sticky_header.style.top = "0";
      sticky_header.classList.add("onscroll");
      let is_transparent_header = document
        .querySelector("html")
        .classList.contains("transparent-header");
      if (!is_transparent_header) {
        document.querySelector("main").style.paddingTop = header_height + "px";
      }
    } else {
      sticky_header.style.position = "initial";
      sticky_header.style.top = "initial";
      sticky_header.classList.remove("onscroll");
      let is_transparent_header = document
        .querySelector("html")
        .classList.contains("transparent-header");
      if (!is_transparent_header) {
        document.querySelector("main").style.paddingTop = "initial";
      }
    }

    let is_transparent_header = document
      .querySelector("html")
      .classList.contains("transparent-header");
    if (is_transparent_header) {
      let breakpoint_el = sticky_header.dataset.scrollbreakpoint;
      let breakpoint_el_height =
        document.querySelector(breakpoint_el).offsetHeight;
      let breakpoint_height =
        breakpoint_el_height + target_height - header_height;
      let header = sticky_header;
      if (window.scrollY <= target_height) {
        header.style.background = "transparent";
      } else if (
        window.scrollY > target_height &&
        window.scrollY < breakpoint_height
      ) {
        header.style.background = "rgba(0,0,0,0.2)";
        let blank_theme_el = header.querySelectorAll(".blank-theme");
        blank_theme_el.forEach(function (a) {
          a.classList.remove("blank-theme");
          a.classList.add("dark-theme");
        });
      } else if (window.scrollY >= breakpoint_height) {
        header.style.background = "white";
        let dark_theme_el = header.querySelectorAll(".dark-theme");
        dark_theme_el.forEach(function (a) {
          a.classList.remove("dark-theme");
          a.classList.add("blank-theme");
        });
      }
    }
  }
}

// trigger resize event
function resize() {
  setTimeout(function () {
    window.dispatchEvent(new Event("resize"));
  }, 100);
}

// Lazy loading for background images

const OnScreenObserverBg = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const element = entry.target;
      const visiblePct = Math.floor(entry.intersectionRatio * 100);

      if (visiblePct > 10) {
        // lazyload execution
        element.classList.add("function-enabled");
        element.style.background = element.dataset.bg;
        element.style.background = "-webkit-" + element.dataset.bg;
        OnScreenObserverBg.unobserve(element);
      }
    });
  },
  { root: null, rootMargin: "0px", threshold: [0.2] }
);
[
  ...document.querySelectorAll(
    '[data-function="bg-lazyload"]:not(.function-enabled)'
  ),
].forEach((el) => OnScreenObserverBg.observe(el));

// Lazy loading for Videos

const OnScreenObserverVid = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const element = entry.target;
      const visiblePct = Math.floor(entry.intersectionRatio * 100);
      element.classList.add("function-enabled");
      const video = element.querySelector("video");

      if (visiblePct > 10) {
        // lazyload execution
        element.querySelector("source").src = element.dataset.src;
        video.load();
        OnScreenObserverVid.unobserve(element);
      }

      const autoplay = element.dataset.autoplay;
      if (!autoplay) {
        const $overlay = element.querySelector(".video-overlay");
        if ($overlay) {
          $overlay.addEventListener("click", () => {
            $overlay.classList.remove("active");
            video.play();
            video.setAttribute("controls", "controls");
          });
        }
      }
    });
  },
  { root: null, rootMargin: "0px", threshold: [0.2] }
);
[
  ...document.querySelectorAll(
    '[data-function="video-lazyload"]:not(.function-enabled)'
  ),
].forEach((el) => OnScreenObserverVid.observe(el));

// Handle screen height

function calc_height() {
  let window_height = window.innerHeight;
  document.documentElement.style.setProperty(
    "--window-height",
    window_height + "px"
  );
}
